import React from "react";

const STYLES = {
  active: "bg-emerald-100 text-emerald-700",
  inactive: "bg-amber-100 text-amber-700",
  suspended: "bg-red-100 text-red-700",
  archived: "bg-slate-200 text-slate-600",
  paused: "bg-amber-100 text-amber-700",
  closed: "bg-slate-200 text-slate-600",
  trial: "bg-blue-100 text-blue-700",
  manual: "bg-purple-100 text-purple-700",
  plan: "bg-sky-100 text-sky-700",
  none: "bg-slate-100 text-slate-600",
};

const LABELS = {
  active: "Activo",
  inactive: "Inactivo",
  suspended: "Suspendido",
  archived: "Archivado",
  paused: "Pausado",
  closed: "Cerrado",
  trial: "Trial",
  manual: "Acceso manual",
  plan: "Plan asignado",
  none: "Sin acceso",
};

export function StatusBadge({ value, testId }) {
  const key = value || "none";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${STYLES[key] || STYLES.none}`}
    >
      {LABELS[key] || key}
    </span>
  );
}
